import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFeatherAlt,
  faTags,
  faTrashAlt,
  faBookOpen,
  faArrowRight,
  faTimes,
  faStar,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTrashAlt as bin,
  faEdit as edit
} from "@fortawesome/free-regular-svg-icons";

library.add(
  faFeatherAlt,
  faTags,
  faTrashAlt,
  faBookOpen,
  faArrowRight,
  faTimes,
  faStar,
  bin,
  edit,
  faChevronDown,
  faChevronUp,
);
